import { isDiscountInOutlowEnabled, isDiscountOutflowOldProduct } from 'reactApp/appHelpers/featuresHelpers/features/discountInOutflow';
import { BuySubscriptionActions, BuySubscriptionSelectors } from 'reactApp/modules/buySubscription/buySubscription.module';
import type {
    CheckOffer,
    OutflowOfferMobileProps,
    OutflowOfferWebProps,
} from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { store } from 'reactApp/store';
import {
    closeDiscountInOutflowModal,
    renderDiscountInOutflowModal,
} from 'reactApp/ui/DiscountInOutflow/DiscountInOutflowModal/DiscountInOutflowModal.helpers';
import { select } from 'typed-redux-saga';

export function* checkDiscountOffer({ product }: CheckOffer) {
    const canDiscountInOutflow = yield* select(BuySubscriptionSelectors.getCanSetDiscountInOutflow);
    return isDiscountInOutlowEnabled && canDiscountInOutflow && !isDiscountOutflowOldProduct(product.id);
}

export function* discountOffer({ subscription, product, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    const discountInOutflow = yield* select(BuySubscriptionSelectors.getDiscountInOutflow);
    yield renderDiscountInOutflowModal({
        subscription,
        product,
        discountPrice: discountInOutflow,

        onCancel() {
            closeDiscountInOutflowModal();
            continueOutflow();
        },
        onClose() {
            closeDiscountInOutflowModal();
            cancelOutflow();
        },
        onSuccess() {
            store.dispatch(
                BuySubscriptionActions.setDiscountInOutflow({
                    subscriptionId: subscription.id,
                })
            );
            closeDiscountInOutflowModal();
            cancelOutflow();
        },
    });
}

export function* discountOfferMobile(props: OutflowOfferMobileProps) {
    yield discountOffer(props);
}
